import { Grid } from 'antd';
import { Footer } from 'antd/es/layout/layout';
import React from 'react';

interface DateInformationFooterProps {
  customStyle?: React.CSSProperties; 
}

export const DateInformationFooter: React.FC<DateInformationFooterProps> = ({ customStyle }) => {
  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;
  return (
    <Footer
      style={{
        fontSize: '12px',
        textAlign: 'center',
        paddingBottom: '65px',
        position: 'fixed',
        width: isMobile ? '100%' : '300px',
        bottom: 0,
        color: 'grey',
        ...customStyle,
      }}
    >
      <p>All times are calculated using Coordinated Universal Time (UTC).</p>
    </Footer>
  );
};